import React from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { CART_PAGE_URL } from '@yme/common/constants';
import { setIsModalHide } from '@yme/modals/actions';
import { getExternalCartEndPoint, getExternalCartLink, getRedirectModalLabels, } from '@yme/selectors/common';
import { getCurrentNavigationLink, getRTL, getRootLang } from '@yme/selectors/index';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getFormattedLanguageRootForProductRelease } from '@yme/utils/common';
import { getCustomerId } from '@yme/utils/externalCustomer';
import { COOKIE_SESSION_EXTERNAL_CART_MODAL, DELAY_BEFORE_REDIRECTION } from './constants';
import { SpinnerContainer } from './styled';
let timerRedirection;
export function RedirectionExternalCartModal() {
    const isRightToLeft = useSelector(getRTL);
    const dispatch = useDispatch();
    const customerId = getCustomerId();
    const shouldBeShow = Cookies.get(COOKIE_SESSION_EXTERNAL_CART_MODAL) !== customerId;
    const rootLanguage = useSelector(getRootLang);
    const formattedRootLanguage = getFormattedLanguageRootForProductRelease(rootLanguage);
    const externalCartLink = useSelector(getExternalCartLink);
    const externalCartEndPoint = useSelector(getExternalCartEndPoint);
    const labels = useSelector(getRedirectModalLabels);
    const homeLink = useSelector(getCurrentNavigationLink);
    const history = useHistory();
    const isCartPage = window.location.href.indexOf(CART_PAGE_URL) > 0;
    const redirectionCartLink = `${externalCartLink}/${formattedRootLanguage}/${externalCartEndPoint}?id=${customerId}`;
    const redirectionExternalCart = () => {
        window.location = redirectionCartLink;
    };
    const homeRedirection = () => {
        if (!homeLink)
            return;
        history.push(homeLink);
    };
    const initTimerRedirection = () => {
        if (timerRedirection) {
            clearTimeout(timerRedirection);
        }
        // TODO: (V.P.) expires: TIME_RANGE_OFFSET ? (Discussing)
        timerRedirection = setTimeout(() => {
            Cookies.set(COOKIE_SESSION_EXTERNAL_CART_MODAL, customerId);
            redirectionExternalCart();
        }, DELAY_BEFORE_REDIRECTION);
    };
    const handleHideModal = function () {
        if (timerRedirection) {
            clearTimeout(timerRedirection);
        }
        dispatch(setIsModalHide());
        if (isCartPage) {
            homeRedirection();
        }
    };
    if (shouldBeShow) {
        initTimerRedirection();
    }
    else {
        redirectionExternalCart();
    }
    return (React.createElement(React.Fragment, null, shouldBeShow && (React.createElement(StaticModalWindow, { title: labels.redirectModalTitle, staticModalSize: MD_MODAL, minHeight: "auto", isRightToLeft: isRightToLeft, onHide: handleHideModal },
        React.createElement(FlexWrapper, { isFullWidth: true, flexDirection: "column" },
            React.createElement(SpinnerContainer, null,
                React.createElement(SpinnerLoader, { isLoading: true })),
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, labels.redirectModalMessage))))));
}
